module.exports = __webpack_public_path__ + "static/media/myteam1.146bd677.jpg";